var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#50E3C2",
    strokeOpacity: 0.088,
    strokeWidth: 1.333,
    d: "M19.333.667H.666v18.667h18.667z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#EB8181",
    strokeWidth: 1.071
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.333 5.833H1.667M15.833 5.833v12.5H4.167v-12.5M11.873 9.584v4.999M8.123 9.584v4.999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.333 5.833V1.667H6.667v4.166"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.7604fd91cf6c29b72e58a560e6009ca4.svg";
export { ForwardRef as ReactComponent };